import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import { getVCTextIdentifier } from 'api/virtual-currency/utils'
import ExternalLink from 'components/shared/ExternalLink'
import IconInput from 'components/shared/inputs/IconInput'
import TextField from 'components/shared/inputs/TextField'
import useFileInput from 'hooks/useFileInput'
import { Controller, useFormContext } from 'react-hook-form'

const VirtualCurrency = () => {
  const platform = 'ios'
  const sdkUrl = platform === 'ios' ? 'iosSdk' : 'androidSdk'

  const { control, watch, setValue } = useFormContext()

  const { inputRef, file } = useFileInput()

  const vcName = watch('virtualCurrencyAttributes.name') as string

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Alert severity="info">
        Multiple virtual currencies are only supported in the{' '}
        <ExternalLink to={sdkUrl}>Fyber SDK</ExternalLink> v7.0 and higher.
      </Alert>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
        }}
      >
        <Controller
          name="vcIcon"
          control={control}
          render={({ field }) => {
            return (
              <IconInput
                {...field}
                initialImageSource={
                  field.value ? URL.createObjectURL(field.value) : null
                }
                sx={{ top: 5 }}
                inputRef={inputRef}
                file={file}
                id="vcIcon"
              />
            )
          }}
        />
        <Controller
          name="virtualCurrencyAttributes.name"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              onChange={(e) => {
                const value = e.target.value

                if (!value?.trim().length) {
                  setValue('createPlacement', false, { shouldValidate: true })
                }
                field.onChange(value)
              }}
              id="vcName"
              label="Name"
              sx={{ width: 240 }}
            />
          )}
        />
        <TextField
          label="ID"
          id="vcTextIdentifier"
          readOnly
          value={getVCTextIdentifier(vcName)}
          sx={{ width: 240 }}
        />
      </Box>
    </Box>
  )
}

export default VirtualCurrency
